import { authService } from "../../auth/services/auth.service";
import { httpService } from "../../core/services/http.service";
import { Eligibility } from "../models/newsletter.models";

// @ts-ignore
// const NL_END_POINT = import.meta.env.VITE_API_NL_ENDPOINT
const API_PATH = 'newsletter/'


export class NewsletterService {
    // token: string;
    // #HEADERS: { [key: string]: string } = {
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json'
    // }

    init() {
        console.log("NewsletterService initialized with jwt");
    }

    async checkEligibility(nlId: string): Promise<Eligibility> {
        try {
            if (!authService.isAuthenticated || !nlId) { throw new Error("Token or nlId not provided") }
            const response = await httpService.query(API_PATH + nlId, { method: 'GET' })
            if (!response.ok) { throw new Error('Failed to fetch newsletter eligibility' + response.statusText) }
            return response.json()
        }
        catch (error) {
            return error.message
        }
    }

    async subscribe(email: string, nlId: string): Promise<any> {
        try {
            if (!nlId) { throw new Error("NlId not provided") }
            if (!authService.isAuthenticated && !email) { throw new Error("Either token or email must be provided") }

            let options = {
                method: 'POST',
                // headers: { ...this.#HEADERS },
                body: JSON.stringify(email ? { email } : {})
            };

            const response = await httpService.query(API_PATH + nlId, options)
            if(response.status === 500) { throw new Error(response.error) }

            return response.json()
        }
        catch (error) {
            return error as Error
        }
    }

    async unsubscribe(nlId: string) {
        try {
            if (!authService.isAuthenticated || !nlId) { throw new Error("Token or nlId not provided") }

            const response = await httpService.query(API_PATH + nlId, {
                method: 'DELETE',
            })
            if (!response.ok) { throw new Error('Failed to unsubscribe from newsletter' + response.statusText) }
            return response.json()
        }
        catch (error) {
            return error.message
        }
    }
}


export const newsletterService = new NewsletterService()